import { render } from "./soldierList.vue?vue&type=template&id=72514731&scoped=true"
import script from "./soldierList.vue?vue&type=script&lang=js"
export * from "./soldierList.vue?vue&type=script&lang=js"

import "./soldierList.vue?vue&type=style&index=0&id=72514731&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72514731"]])

export default __exports__